export default "__VITE_ASSET__9Mszc1V9__"